<script setup>
import {onMounted, ref, watch} from 'vue'
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {authData} from '@/services/AuthService';
import Input from "@/components/forms/Input.vue";
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

const props = defineProps({
  clientCode: {type: String, required: true},
});

const clientCode = ref('');

const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);
const closeModalWith = (value) => {
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', clientCode.value);
      isOpen.value = false;
    } else {
      emit('cancel');
      isOpen.value = false;
    }
  }, 300);
}

onMounted(() => {
  clientCode.value = props.clientCode;
});

function openModal() {
  isOpen.value = true
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('changeClientCodeModal.change_client_code') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')">
              <div class="modal-body">
                <div class="row mb-3">
                  <div class="col-12">
                    <label for="clientCodeInput" class="form-label">{{ t('changeClientCodeModal.client_code') }}</label>
                    <input v-model="clientCode" id="clientCodeInput" class="form-control" type="text"/>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">{{ t('changeClientCodeModal.cancel') }}</button>
                <button class="btn btn-primary btn-md" type="submit">{{ t('changeClientCodeModal.save') }}</button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

